import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ChefFigure } from "../Chef";

const DISMISSED_KEY = "opm:chefBubbleDismissed";
const readDismissed = () => {
  try {
    return sessionStorage.getItem(DISMISSED_KEY) === "1";
  } catch {
    return false;
  }
};

/**
 * The chef peeking in from the bottom corner of the menu, with a speech bubble: the way into
 * the assistant chat. Closing the bubble tucks the chef further out of the way for the rest
 * of the visit; he still opens the chat when tapped. Only the bubble and the chef take taps;
 * the dishes around them stay tappable.
 */
const ChefPeek = ({ bottom }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(() => !readDismissed());
  const openChat = () => navigate("/assistant");
  const dismiss = () => {
    setOpen(false);
    try {
      sessionStorage.setItem(DISMISSED_KEY, "1");
    } catch {
      /* the bubble just comes back on the next visit */
    }
  };

  return (
    <div className="fixed left-0 z-30 w-[300px] h-[190px] pointer-events-none" style={{ bottom }}>
      {open && (
        <div className="chef-bubble pointer-events-auto absolute left-[112px] -top-3.5" style={{ transformOrigin: "0% 100%" }}>
          <div className="chef-bubble-in relative">
            <button
              type="button"
              onClick={openChat}
              className="flex flex-col gap-0.5 whitespace-nowrap ps-4 pe-[18px] py-3 bg-surface shadow-toast text-start"
              style={{ borderRadius: "20px 20px 20px 6px" }}
            >
              <span className="text-base leading-[21px] font-bold text-dark">{t("chefBubbleLine1")}</span>
              <span className="text-base leading-[21px] font-bold text-dark">{t("chefBubbleLine2")}</span>
              <span className="text-sm font-bold text-primary">{t("chefBubbleCta")}</span>
            </button>
            <button
              type="button"
              onClick={dismiss}
              aria-label={t("chefBubbleClose")}
              className="absolute -top-[18px] -right-[18px] w-11 h-11 flex items-center justify-center"
            >
              <span className="w-[26px] h-[26px] rounded-full bg-dark border-2 border-white shadow-raised flex items-center justify-center text-white">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" aria-hidden="true">
                  <path d="M6 6l12 12M18 6L6 18" />
                </svg>
              </span>
            </button>
          </div>
        </div>
      )}
      <button
        type="button"
        onClick={openChat}
        aria-label={t("chefOpenChat")}
        className={`chef-body pointer-events-auto absolute -left-[30px] bottom-0 block w-[140px] h-[160px] ${open ? "" : "tucked"}`}
      >
        <ChefFigure />
      </button>
    </div>
  );
};

export default ChefPeek;
